<script lang="ts">
  import SRLCCLogo from 'images/gateways/srlcc/logo-srlcc.png'
</script>

<div>
  <a href="/">
    <h1>
      <div>
        <img src={SRLCCLogo} alt={window.gettext('Southern Rockies LCC Conservation Planning Atlas')} />
        <div>{window.gettext('SOUTHERN ROCKIES')}</div>
        <div>{window.gettext('Landscape Conservation Cooperative')}</div>
      </div>
    </h1>
    <h2>{window.gettext('Conservation Planning Atlas')}</h2>
  </a>
</div>

<style lang="scss">
  div {
    position: relative;
    font-family: $default-font-family;
    width: 500px;

    h1 {
      height: 48px;
      position: absolute;
      top: 8px;
      left: -14px;
      background-color: $primary-5;
      width: 1002px;
      border-radius: 6px;

      > div {
        color: white;
        margin-left: 36px;
        padding: 8px;

        img {
          float: left;
          position: relative;
          top: -22px;
        }

        :nth-child(2) {
          font-size: 21px;
        }

        :nth-child(3) {
          font-size: 14px;
        }
      }
    }

    h2 {
      position: absolute;
      top: 69px;
      left: 111px;
      font-size: $font-size-3;
      font-weight: 700;
      color: $primary-1;
    }
  }
</style>
